<div class="toolbarContainer">
    <button class="headerbtn" aria-label="search" (click)="toggleSearch($event)">
        <img src="../../../assets/icons/search-md.png" alt="">
        <div style="font-weight: 400;font-size:12px;color:var(--coralgrey)" multilang>Suchen</div>
    </button>
    <button aria-label="favorite" [matBadge]="favoritesCount > 0 ? favoritesCount : ''" matBadgePosition="before"
        matBadgeColor="warn" (click)="gotofavorites()" class="headerbtn">
        <img src="../../../assets/icons/heart.png" alt="">
        <div style="font-weight: 400;font-size:12px;color:var(--coralgrey)" multilang>Favoriten</div>
    </button>

    <button aria-label="menu" class="headerbtn cc9" (click)="openMenu($event)">
        <img src="../../../assets/icons/menu.png" alt="">
        <div style="font-weight: 400;font-size:12px;color:var(--coralgrey)" multilang>Menü</div>
    </button>
</div>